module.exports = __webpack_public_path__ + "media/packs/images/update-icons/truck-b028c13af66b6ec779c09e66a96f34df.svg";